/***
 * Configuration for Planning Routes
 *
 * Calendar Route
 * Planning Management Route
 ***/

/* ----- Views ----- */

// Planning
import Calendar from "@/pages/Planning/Calendar/Calendar";
import Management from "@/pages/Planning/Management/Management";

/* ----- ----- ----- ----- ----- ----- ----- */

const planningRoutes = [
    {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar,
        meta: {
            route: {
                label: 'Calendrier'
            }
        },
    },
    {
        path: 'planning_management',
        name: 'Planning Management',
        component: Management,
        meta: {
            route: {
                label: 'Gestion du planning d\'intervention'
            }
        },
    },
]

const routes = [...planningRoutes]
export default routes